var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1678 15.4434C18.3175 13.9319 19 12.0456 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 12.0457 1.68251 13.932 2.83224 15.4435C3.81777 13.4611 5.60156 11.9451 7.7635 11.3168C6.69953 10.598 6 9.38068 6 8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8C14 9.38067 13.3005 10.598 12.2365 11.3168C14.3985 11.945 16.1823 13.461 17.1678 15.4434ZM17.601 16.4984C19.0967 14.7505 20 12.4808 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 12.4808 0.903365 14.7506 2.39909 16.4984C2.3989 16.499 2.39872 16.4996 2.39854 16.5001L2.4013 16.501C4.23537 18.6428 6.95919 20 10 20C13.0408 20 15.7646 18.6428 17.5987 16.5011L17.6016 16.5001C17.6014 16.4995 17.6012 16.4989 17.601 16.4984ZM16.4505 16.2762C15.3879 13.7628 12.8993 12 10.0001 12C7.1008 12 4.61215 13.7629 3.54957 16.2763C5.18461 17.9564 7.47043 19 10 19C12.5296 19 14.8155 17.9564 16.4505 16.2762ZM10 11C11.6569 11 13 9.65685 13 8C13 6.34315 11.6569 5 10 5C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.5e0e427f38101caa04e0923aa2a0de3d.svg";
export { ForwardRef as ReactComponent };